import { platform} from './Constants';

//获取ios版本
export function getIOSVersion() {
  if(!platform.ios) {
    return null;
  }

  const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    const version = [
      Number.parseInt(match[1]),
      Number.parseInt(match[2] || '0'),
      Number.parseInt(match[3] || '0')
    ].join('.');
    //目前只需要用到主和子版本号(修正版本号暂时不需要)
    return Number.parseFloat(version);
}

//获取android版本
export function getAndroidVersion() {
  if(!platform.android) {
    return null;
  }

  const ua = navigator.userAgent.toLowerCase();
  // eslint-disable-next-line
    const match = ua.match(/android\s([0-9\.]*)/);
    //目前只需要用到主和子版本号(修正版本号暂时不需要)
    return match ? Number.parseFloat(match[1]) : null;
}
